<template>
  <div class="form-panel"> 
    
    <div class="form-panel__header">
      <h2 class="titulo-h2">¿Olvidaste tu Contraseña?</h2>
    </div>
    <div class="form-panel__body">
      <div class="form-fields form-fields-register">               
        <div class="form-fields__principal">
          <h2 class="titulo-h3-light">Ingresa el correo con el cual te registraste</h2> 
          <form class="form" action="">  
            <div class="form__group" :class="{'form__group-invalid': $v.email.$error, 'form__group-valid': !$v.email.$invalid}">
              <i class="icon-field icon-field-email"></i>        
              <label for="email">Email</label>
              <input id="email" type="email" autofocus @blur="$v.email.$touch()" v-model="email">
              <div class="form__group-validation" v-if="$v.email.$dirty">
                <p v-if="!$v.email.required">Debes especificar un correo.</p>
                <p v-if="!$v.email.email">El formato de correo no es válido.</p>
              </div>
            </div>
            <div class="form__group form__group-register">
              <a class="waves-effect waves-light m-btn" @click="$v.email.$invalid ? $v.email.$touch() : enviar()">Enviar Código</a>               
            </div>   
          </form>
        </div>  
      </div>
    </div>
  </div>   
</template>

<script>

import { required, email } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex'

export default {
  data(){
    return{
      email: ''
    };
  },
  methods: {
    enviar(){
      this.$store.dispatch('forgotPassword', this.email)
    }
  },
  validations: {
    email: {
      required,
      email
    }
  }
}
</script>